import {Container} from "@bryntum/schedulerpro";

class SwivuTabBase extends Container {
  //Todo: Destroy all listeners in a tab from here.
  onSwivuEditorHide() {
    if (this.swivuDeleteButtonListener) this.swivuDeleteButtonListener()
  }

  static get type() {
    return "swivutabbase"
  }
}
export default SwivuTabBase;